<script setup>
import { computed, inject, onMounted, onUnmounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

import { useHeightComposable } from '@/composables/useHeightComposable'

import GenerateTab from '@/components/reinforcement/GenerateTab.vue'
import OptionsTab from '@/components/reinforcement/OptionsTab.vue'
import ReinforcementLineChart from '@/components/reinforcement/ReinforcementLineChart.vue'
import TabTemplate from '@/components/common/TabTemplate.vue'

const store = useStore()

const topHeight = inject('topHeight')
const tab = ref(0)
const tabsRef = ref(null)
const tabsRefHeight = ref(0)

const reduceHeight = computed(() => {
  return topHeight?.value + tabsRefHeight.value + 'px'
})

const { mountObserver, unmountObserver } = useHeightComposable(tabsRefHeight, tabsRef)

const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

const currentStabSchematisationStageId = computed(() => currentStabSchematisationStage.value?.id)

watch(currentStabSchematisationStageId, async (newId) => {
  if (newId) {
    await fetchRelatedData()
  }
})
const fetchReinforcementGenerateOptions = async () =>
  store.dispatch('reinforcementGenerate/fetchOptions')
const fetchReinforcementInput = async (id) => store.dispatch('reinforcementGenerate/fetchItem', id)
const fetchCrestLevelOvertoppingRates = async () =>
  store.dispatch('reinforcementGenerate/fetchCrestLevelOvertoppingRates')

const fetchReinforcement = async (id) => store.dispatch('reinforcement/fetchItems', id)
const fetchReinforcementPoints = async (id) => store.dispatch('reinforcementPoint/fetchItems', id)
const fetchReinforcementPointOptions = async () => store.dispatch('reinforcementPoint/fetchOptions')
const fetchRelatedData = async () => {
  await fetchReinforcementGenerateOptions()
  await fetchCrestLevelOvertoppingRates()
  await fetchReinforcementInput(currentStabSchematisationStage.value.reinforcement_input)
  await fetchReinforcement(currentStabSchematisationStageId.value)
  await fetchReinforcementPoints(currentStabSchematisationStageId.value)
  await fetchReinforcementPointOptions()
}
onMounted(async () => {
  await mountObserver()
  await fetchRelatedData()
})

onUnmounted(() => {
  unmountObserver()
})
</script>
<template>
  <TabTemplate>
    <template v-slot:chart>
      <ReinforcementLineChart />
    </template>
    <template v-slot:content>
      <v-tabs v-model="tab" fixed-tabs>
        <v-tab width="50%" ref="tabsRef" color="primary">Generate</v-tab>
        <v-tab width="50%" color="primary">Reinforcement Options</v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <GenerateTab />
        <OptionsTab />
      </v-window>
    </template>
  </TabTemplate>
</template>
<style scoped>
.v-window {
  height: calc(100vh - v-bind(reduceHeight));
  margin: 0;
}
</style>
